// Get html for pricing page
const getHTML = url =>
  new Promise((resolve, reject) => {
    if (!window.XMLHttpRequest) return;
    const xhr = new XMLHttpRequest();

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(xhr.response);
      } else {
        reject(xhr.statusText);
      }
    };

    xhr.open('GET', url);
    xhr.send();
  });

export default getHTML;
